import React from "react";
import styled from 'styled-components';

const HeaderStyle = styled.div`
    width: 90%;
    margin: 2rem 5rem 1rem;
    text-align:start;
    border-top: 1px solid #ccc;
    padding-top: 2rem ;
    p{
        margin: 0 -2rem;
    }
    `;
const Header =(props)=>{
    return(
        <HeaderStyle>
           <p style={{ color:props.color , fontSize:props.size + 'rem' , fontWeight:props.weight}}>
               {props.data}
            </p> 
        </HeaderStyle>

    )

}
export default Header;